export enum QueryKey {
  generateWhitelistLink = 'generateWhitelistLink',
  getFreeMembers = 'getFreeMembers',
  getGroupResourceDetails = 'getGroupResourceDetails',
  getProductDetails = 'getProductDetails',
  getResourceDetails = 'getResourceDetails',
  removeFreeMember = 'removeFreeMember',
}
